export default __webpack_public_path__ + "static/6-2d9c4e46dc4c2d859b5db700b3e8c196.png";